import React, { useState, useEffect } from 'react';
import './Feed.css';
import TweetBox from './TweetBox';
import Post from './Post';
import db from './firebase';
import FlipMove from 'react-flip-move';

function Feed() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    db.collection('posts')
      .orderBy('id', 'desc')
      .onSnapshot(snapshot => {
        let temp = snapshot.docs.map(doc => doc.data());
        let tempId = snapshot.docs.map(doc => doc.id);
        // temp.forEach((x, tempId) => (x.postId = doc.id));
        for (let i = 0; i < tempId.length; i++) {
          temp[i].postId = tempId[i];
        }

        setPosts(temp);
      });
  }, []);

  return (
    <div className='feed'>
      {/* Header */}
      <div className='feed__header'>
        <h2>Home</h2>
      </div>

      {/* TweetBox */}
      <TweetBox />

      <FlipMove>
        {posts.map(
          (
            {
              displayName,
              username,
              verified,
              text,
              image,
              avatar,
              liked,
              postId,
            },
            i
          ) => (
            <Post
              key={i++}
              postId={postId}
              displayName={displayName}
              username={username}
              verified={verified}
              text={text}
              image={image}
              avatar={avatar}
              liked={liked}
            />
          )
        )}
      </FlipMove>
    </div>
  );
}

export default Feed;
